import { z } from "zod/v4";

export const badgeTierSchema = z.enum(["blue", "gold"]);

export const badgeStatusSchema = z.enum([
	"pending_review",
	"approved",
	"rejected",
	"active",
	"expired",
	"cancelled",
]);

export const evidenceSchema = z.object({
	legal_name: z.string().optional(),
	registration_number: z.string().optional(),
	website: z.string().optional(),
	notes: z.string().optional(),
});

export const clubBadgeSchema = z.object({
	id: z.string(),
	club_id: z.string(),
	tier: badgeTierSchema,
	status: badgeStatusSchema,
	evidence: evidenceSchema.optional(),
	rejection_reason: z.string().nullable().optional(),
	price_cents: z.number(),
	currency: z.string(),
	starts_at: z.string().nullable().optional(),
	expires_at: z.string().nullable().optional(),
	created_at: z.string(),
	updated_at: z.string(),
});

export const badgePricingTierSchema = z.object({
	tier: badgeTierSchema,
	price_cents: z.number(),
	currency: z.string(),
	label: z.string(),
	duration_days: z.number(),
});

export const badgePricingSchema = z.object({
	tiers: z.array(badgePricingTierSchema),
});

export const badgeStatusResponseSchema = z.object({
	auto_gold: z.boolean(),
	effective_tier: z.enum(["blue", "gold", ""]),
	badge: clubBadgeSchema.nullable().optional(),
});

export const badgeCheckoutResponseSchema = z.object({
	checkout_url: z.string(),
	badge_id: z.string(),
});

export const adminBadgeQueueItemSchema = clubBadgeSchema.extend({
	club_name: z.string(),
	club_avatar_url: z.string().nullable().optional(),
});

export const adminBadgeListResponseSchema = z.object({
	items: z.array(adminBadgeQueueItemSchema),
	total: z.number(),
	limit: z.number().optional(),
	offset: z.number().optional(),
	next_cursor: z.string().nullable().optional(),
});

export type BadgeTier = z.infer<typeof badgeTierSchema>;
export type BadgeStatus = z.infer<typeof badgeStatusSchema>;
export type Evidence = z.infer<typeof evidenceSchema>;
export type ClubBadge = z.infer<typeof clubBadgeSchema>;
export type BadgePricingTier = z.infer<typeof badgePricingTierSchema>;
export type BadgePricing = z.infer<typeof badgePricingSchema>;
export type BadgeStatusResponse = z.infer<typeof badgeStatusResponseSchema>;
export type BadgeCheckoutResponse = z.infer<typeof badgeCheckoutResponseSchema>;
export type AdminBadgeQueueItem = z.infer<typeof adminBadgeQueueItemSchema>;
export type AdminBadgeListResponse = z.infer<typeof adminBadgeListResponseSchema>;
